import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    id: "",
    isDirty: false
};

const appSlice = createSlice({
    name: "currentPage",
    initialState: initialState,
    reducers:{
       setCurrentPage: (state, action) => ({...action.payload}),
       setCurrentPageIsDirty: (state, action) => ({...state, isDirty: action.payload})
    }
});

export default appSlice.reducer;

export const { setCurrentPage, setCurrentPageIsDirty } = appSlice.actions;

